(function () {
  const SECTION_SELECTOR = '.shoppable-videos';

  function getVideos(section) {
    return Array.from(section.querySelectorAll('.shoppable-video-card__video'));
  }

  function getMuteButtons(section) {
    return Array.from(section.querySelectorAll('.shoppable-video-card__mute'));
  }

  function getSwiper(section) {
    return section.querySelector('.shoppable-videos__swiper')?.productCarouselSwiper || null;
  }

  function getActiveSlide(section) {
    const swiper = getSwiper(section);

    if (swiper?.el) {
      return (
        swiper.slides?.[swiper.activeIndex] ||
        swiper.el.querySelector('.swiper-slide-active')
      );
    }

    return (
      section.querySelector('.swiper-slide-active') ||
      section.querySelector('.shoppable-video__slide:not([data-shoppable-clone])')
    );
  }

  function getActiveVideo(section) {
    return getActiveSlide(section)?.querySelector('.shoppable-video-card__video') || null;
  }

  function upgradePoster(video) {
    if (!video) return;

    const poster = video.getAttribute('poster');
    if (poster && poster.includes('_small')) {
      video.setAttribute('poster', poster.replace('_small', ''));
    }

    video.querySelectorAll('img').forEach((img) => {
      const src = img.getAttribute('src');
      if (src && src.includes('_small')) {
        img.setAttribute('src', src.replace('_small', ''));
      }
    });
  }

  // function playVideo(video) {
  //   if (!video) return;

  //   video.muted = true;
  //   video.defaultMuted = true;
  //   video.loop = true;
  //   video.playsInline = true;
  //   video.setAttribute('muted', '');
  //   video.setAttribute('playsinline', '');
  //   video.setAttribute('webkit-playsinline', '');

  //   // Make sure the video we're about to play is actually allowed to buffer.
  //   // On iOS Safari, videos left at preload="none" won't have enough data
  //   // to start playback quickly, so promote it back to "auto" here.
  //   if (video.preload !== 'auto') {
  //     video.preload = 'auto';
  //   }

  //   const tryPlay = () => {
  //     const playPromise = video.play();
  //     if (playPromise && typeof playPromise.catch === 'function') {
  //       playPromise.catch(() => {});
  //     }
  //   };

  //   if (video.readyState >= 2) {
  //     tryPlay();
  //     return;
  //   }

  //   video.addEventListener('canplay', tryPlay, { once: true });
  //   if (video.readyState === 0) {
  //     video.load();
  //   }
  // }

  function playVideo(video) {
    if (!video) return;

    video.loop = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    // Make sure the video we're about to play is actually allowed to buffer.
    if (video.preload !== 'auto') {
      video.preload = 'auto';
    }

    const tryPlay = () => {
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    if (video.readyState >= 2) {
      tryPlay();
      return;
    }

    video.addEventListener('canplay', tryPlay, { once: true });
    if (video.readyState === 0) {
      video.load();
    }
  }

  function pauseVideo(video) {
    if (!video) return;
    video.pause();
  }

  function setVideoMuted(video, muted) {
    if (!video) return;
    video.muted = muted;
  }

  function updateMuteButton(button, muted) {
    if (!button) return;

    const mutedIcon = button.querySelector('.shoppable-video-card__mute-icon--muted');
    const unmutedIcon = button.querySelector('.shoppable-video-card__mute-icon--unmuted');

    button.dataset.muted = muted ? 'true' : 'false';
    button.setAttribute('aria-pressed', muted ? 'false' : 'true');
    button.setAttribute(
      'aria-label',
      muted ? button.dataset.labelUnmute || 'Unmute video' : button.dataset.labelMute || 'Mute video'
    );

    if (mutedIcon) mutedIcon.hidden = !muted;
    if (unmutedIcon) unmutedIcon.hidden = muted;
  }

  function muteAllInSection(section) {
    getVideos(section).forEach((video) => setVideoMuted(video, true));
    getMuteButtons(section).forEach((button) => updateMuteButton(button, true));
  }

  function muteAllSections() {
    document.querySelectorAll(SECTION_SELECTOR).forEach((section) => muteAllInSection(section));
  }

  function pauseAll(section) {
    getVideos(section).forEach((video) => pauseVideo(video));
    section.querySelectorAll('.shoppable-video-card').forEach((card) => {
      card.classList.remove('is-playing');
    });
  }

  // iOS Safari only allows a small number of <video> elements to buffer/
  // decode concurrently. Loop mode in Swiper also clones slides, which
  // multiplies the number of <video> tags in the DOM. If every video is
  // set to preload="auto", they all compete for the same limited decoder
  // pipeline and the one you actually want to play can stall for a long
  // time even though its file size is small. To avoid this, only the
  // active video (and optionally the next one) is kept at preload="auto";
  // everything else is dropped to preload="none" so it releases its
  // buffered data and decoder slot.
  function throttlePreload(section, activeVideo) {
    getVideos(section).forEach((video) => {
      if (video === activeVideo) {
        if (video.preload !== 'auto') {
          video.preload = 'auto';
        }
      } else if (video.preload !== 'none') {
        video.preload = 'none';
      }
    });
  }

  function syncPlayback(section) {
    if (!section) return;

    if (section.shoppableVideosVisible === false) {
      pauseAll(section);
      return;
    }

    if (!getSwiper(section)) {
      pauseAll(section);
      return;
    }

    const activeSlide = getActiveSlide(section);
    const activeVideo = activeSlide?.querySelector('.shoppable-video-card__video') || null;

    section.querySelectorAll('.shoppable-video-card').forEach((card) => {
      card.classList.toggle('is-playing', card.closest('.swiper-slide') === activeSlide);
    });

    throttlePreload(section, activeVideo);

    getVideos(section).forEach((video) => {
      if (video === activeVideo) {
        playVideo(video);
      } else {
        pauseVideo(video);
      }
    });
  }

  function toggleMute(section, button) {
    const card = button.closest('.shoppable-video-card');
    const video = card?.querySelector('.shoppable-video-card__video');
    if (!video) return;

    button.dataset.labelUnmute = button.dataset.labelUnmute || button.getAttribute('aria-label') || 'Unmute video';
    button.dataset.labelMute = button.dataset.labelMute || 'Mute video';

    const shouldUnmute = video.muted;

    muteAllInSection(section);

    if (shouldUnmute) {
      setVideoMuted(video, false);
      updateMuteButton(button, false);
      if (video === getActiveVideo(section)) {
        playVideo(video);
      }
    }
  }

  function bindVideoControls(section) {
    if (section.dataset.shoppableVideosBound === 'true') return;
    section.dataset.shoppableVideosBound = 'true';
    section.shoppableVideosVisible = true;

    getVideos(section).forEach((video, index) => {
      upgradePoster(video);
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');

      // Only eagerly buffer the first video on initial load. The rest stay
      // on preload="none" until they actually become the active slide
      // (see throttlePreload / syncPlayback). This is the key fix for the
      // iPhone Safari stall — too many concurrently-buffering videos
      // overwhelm iOS's decoder limit even when each file is small.
      video.preload = index === 0 ? 'auto' : 'none';
      pauseVideo(video);

      video.addEventListener('playing', () => {
        const card = video.closest('.shoppable-video-card');
        if (card) card.classList.add('has-video-frame');
      });
    });

    getMuteButtons(section).forEach((button) => {
      if (!button.dataset.labelUnmute) {
        button.dataset.labelUnmute = button.getAttribute('aria-label') || 'Unmute video';
      }
      if (!button.dataset.labelMute) {
        button.dataset.labelMute = 'Mute video';
      }
    });

    const onMuteClick = (event) => {
      const button = event.target.closest('.shoppable-video-card__mute');
      if (!button || !section.contains(button)) return;
      event.preventDefault();
      event.stopPropagation();
      toggleMute(section, button);
    };

    section.addEventListener('click', onMuteClick);
    section.shoppableVideosMuteHandler = onMuteClick;

    const onSlideChange = () => syncPlayback(section);
    section.addEventListener('shoppable-videos:ready', onSlideChange);
    section.addEventListener('shoppable-videos:slide-change', onSlideChange);
    section.shoppableVideosSlideHandler = onSlideChange;

    if (!getSwiper(section)) {
      let attempts = 0;
      const timer = window.setInterval(() => {
        attempts += 1;
        if (getSwiper(section) || attempts > 40) {
          window.clearInterval(timer);
          delete section.shoppableVideosReadyTimer;
          syncPlayback(section);
        }
      }, 50);
      section.shoppableVideosReadyTimer = timer;
    }

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            section.shoppableVideosVisible = entry.isIntersecting;
            if (entry.isIntersecting) {
              syncPlayback(section);
            } else {
              muteAllInSection(section);
              pauseAll(section);
            }
          });
        },
        { threshold: 0, rootMargin: '120px 0px' }
      );

      observer.observe(section);
      section.shoppableVideosObserver = observer;
    }

    syncPlayback(section);
    requestAnimationFrame(() => syncPlayback(section));
  }

  function unbindVideoControls(section) {
    if (section.shoppableVideosReadyTimer) {
      window.clearInterval(section.shoppableVideosReadyTimer);
      delete section.shoppableVideosReadyTimer;
    }

    if (section.shoppableVideosObserver) {
      section.shoppableVideosObserver.disconnect();
      delete section.shoppableVideosObserver;
    }

    if (section.shoppableVideosMuteHandler) {
      section.removeEventListener('click', section.shoppableVideosMuteHandler);
      delete section.shoppableVideosMuteHandler;
    }

    if (section.shoppableVideosSlideHandler) {
      section.removeEventListener('shoppable-videos:ready', section.shoppableVideosSlideHandler);
      section.removeEventListener('shoppable-videos:slide-change', section.shoppableVideosSlideHandler);
      delete section.shoppableVideosSlideHandler;
    }

    delete section.dataset.shoppableVideosBound;
  }

  function initShoppableVideos(root) {
    const scope = root || document;

    scope.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      bindVideoControls(section);
    });
  }

  function destroyShoppableVideos(root) {
    const scope = root || document;

    scope.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      unbindVideoControls(section);
      muteAllInSection(section);
      pauseAll(section);
    });
  }

  document.addEventListener('theme-drawer:open', muteAllSections);
  document.addEventListener('toggle', (event) => {
    if (event.target instanceof HTMLDetailsElement && event.target.open) {
      muteAllSections();
    }
  }, true);

  document.addEventListener('DOMContentLoaded', () => initShoppableVideos());
  document.addEventListener('shopify:section:load', (event) => initShoppableVideos(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyShoppableVideos(event.target));
})();